import { Controller } from "@hotwired/stimulus"

// Soumet le formulaire de recherche du drawer étudiants avec un petit debounce,
// pour que Turbo Frame recharge la liste sans rebâtir tout le drawer.
export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 250 } }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  submit() {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }
}
